<template src="@/templates/reports/jobsItem.html"></template>

<script>
	export default {
		name: "JobsItem",
		props: ['jobsRowData','styles'],
		created() {
			console.log(this.styles);
            console.log(this.jobsRowData);
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/reports/JobsItem.vue